import { render, staticRenderFns } from "./VersionUpdateLogManagement.vue?vue&type=template&id=29459f4f&scoped=true"
import script from "./VersionUpdateLogManagement.vue?vue&type=script&lang=js"
export * from "./VersionUpdateLogManagement.vue?vue&type=script&lang=js"
import style0 from "./VersionUpdateLogManagement.vue?vue&type=style&index=0&id=29459f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29459f4f",
  null
  
)

export default component.exports